import { Pipe, PipeTransform } from '@angular/core';
import { floor } from 'lodash';

@Pipe( {
    name: 'minuteSecondPipe',
} )
export class MinuteSecondPipePipe implements PipeTransform {

    transform( value: unknown, ...args: unknown[] ): unknown {
        if ( value === null ) {
            //for some cases in variance and standard deviation when there's only a single entry the value is null
            //In those cases 0 would be correct since there's only a single entry, therefore no deviation
            return '00:00';
        }
        const [minutes, _] = String( value ).split( '.' );
        const minutesPadded = minutes.padStart( 2, '0' );
        let secondsAsDecimal = Number( value ) - ( floor( Number( value ) ) );
        let secondsTimeFormat = String( floor( secondsAsDecimal * 60.0 ) );
        const secondsPadded = secondsTimeFormat.padStart( 2, '0' );
        return minutesPadded + ':' + secondsPadded;
    }

}
